import { MyAssortmentTFunction } from '@retail/my-assortment/i18n';

export const centralAssortmentColumnHeaders = (
  t: MyAssortmentTFunction
): Record<CentralAssortmentExportColumn, string> => ({
  inAssortment: t('myAssortment.status.inAssortment'),
  mgItemNumber: t('myAssortment.productCard.mgItemNr'),
  finfoNumber: t('myAssortment.columns.finfoNumber'),
  nobbNumber: t('myAssortment.columns.nobbNumber'),
  primaryGtin: t('myAssortment.columns.primaryUnitGtin'),
  primaryText: t('myAssortment.columns.itemText'),
  secondaryText: t('myAssortment.columns.secondaryText'),
  supplierNumber: t('myAssortment.columns.supplierNumber'),
  supplierName: t('myAssortment.columns.supplier'),
  productGroupNumber: t('myAssortment.columns.itemGroup'),
  productGroupName: t('myAssortment.columns.productGroupNumber'),
  priority: t('myAssortment.priority.priority'),
  priorityValidFrom: t('myAssortment.columns.priorityValidFrom'),
  priorityValidTo: t('myAssortment.columns.priorityValidTo'),
  assortmentTag: t('myAssortment.columns.subAssortments'),
  tagFrom: t('myAssortment.columns.inSubAssortmentFrom'),
  tagTo: t('myAssortment.columns.inSubAssortmentTo'),
  discontinuationDate: t('myAssortment.columns.discontinuationDate'),
  discontinuationStatus: t('myAssortment.columns.discontinuation'),
  addedBy: t('myAssortment.columns.addedBy'),
});

export type CentralAssortmentExportColumn =
  | 'inAssortment'
  | 'mgItemNumber'
  | 'finfoNumber'
  | 'nobbNumber'
  | 'primaryGtin'
  | 'primaryText'
  | 'secondaryText'
  | 'supplierNumber'
  | 'supplierName'
  | 'productGroupNumber'
  | 'productGroupName'
  | 'priority'
  | 'priorityValidFrom'
  | 'priorityValidTo'
  | 'assortmentTag'
  | 'tagFrom'
  | 'tagTo'
  | 'discontinuationStatus'
  | 'discontinuationDate'
  | 'addedBy';
